<template>
    <form @submit.prevent="captchaSubmit">
        <SkippableCaptcha ref="captcha" @verify="ajaxSubmit"></SkippableCaptcha>

        <slot :fields="fields" :is-loading="isLoading" :error="error" :is-finished="isFinished"></slot>
    </form>
</template>

<script>
    import axios from 'axios';
    import jsonp from 'axios-jsonp';
    import SkippableCaptcha from "../util/SkippableCaptcha";

    export default {
        name: 'RecoverPasswordForm',

        components: {SkippableCaptcha},

        props: {
            recoverPasswordUrl: {type: String, required: true},
            returnUrl: {type: String, required: true},
        },

        data() {
            return {
                fields: {
                    email: '',
                },
                error: '',
                isLoading: false,
                isFinished: false,
                language: window.variables.language
            };
        },

        methods: {
            validate() {
                return !!this.fields.email;
            },
            captchaSubmit() {
                if (!this.validate()) {
                    return;
                }

                this.$refs.captcha.execute();
            },
            ajaxSubmit(reCaptchaCode) {
                this.isLoading = true;

                axios({
                    url: this.recoverPasswordUrl,
                    adapter: jsonp,
                    params: {
                        email: this.fields.email,
                        return_url: this.returnUrl,
                        language: this.language,
                        'g-recaptcha-response': reCaptchaCode,
                    },
                }).then(response => {
                    this.isLoading = false;
                    if (response.data.hasOwnProperty('errors')) {
                        this.error = response.data.errors;
                    } else {
                        this.isFinished = true;
                    }
                });
            }
        },
    }
</script>
